var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#6B7280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 3H4.125C2.953 3 2 3.897 2 5V19C2 20.103 2.953 21 4.125 21H19.875C21.047 21 22 20.103 22 19V5C22 3.897 21.047 3 19.875 3ZM19.875 19H4.125C4.068 19 4.029 18.984 4.012 18.984C4.005 18.984 4.001 18.986 4 18.992L3.988 5.046C3.995 5.036 4.04 5 4.125 5H19.875C19.954 5.001 19.997 5.028 20 5.008L20.012 18.954C20.005 18.964 19.96 19 19.875 19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H12V13H6V7ZM13 15H6V17H18V15H14H13ZM14 11H18V13H14V11ZM14 7H18V9H14V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.364e2c41787ca2f89eca9cf1786b2fc3.svg";
export { ForwardRef as ReactComponent };